import React, { createContext, useContext, useState, useCallback } from "react";
import translations from "./translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("r4pro_lang") || "it");

  const setLanguage = useCallback((l) => {
    setLang(l);
    localStorage.setItem("r4pro_lang", l);
  }, []);

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "it" ? "en" : "it";
      localStorage.setItem("r4pro_lang", next);
      return next;
    });
  }, []);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let cur = translations[lang];
      for (const p of parts) {
        if (cur && typeof cur === "object" && p in cur) cur = cur[p];
        else return path;
      }
      return cur;
    },
    [lang]
  );

  return (
    <I18nContext.Provider value={{ lang, setLanguage, toggle, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
}
